import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-userL",
  "use": "icon-userL-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-userL\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 160c-123.36 0-224 100.64-224 224 0 77.12 39.36 145.6 99.008 186.016C272.864 618.976 192 732.256 192 864h64c0-141.76 114.24-256 256-256s256 114.24 256 256h64c0-131.744-80.864-244.992-195.008-294.016A224.768 224.768 0 0 0 736 384c0-123.36-100.64-224-224-224z m0 64c88.736 0 160 71.264 160 160s-71.264 160-160 160-160-71.264-160-160 71.264-160 160-160z\" p-id=\"1146\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/userL.svg
// module id = kQ3N
// module chunks = 7